import { render, staticRenderFns } from "./ExtratoTotal.vue?vue&type=template&id=18180662"
import script from "./ExtratoTotal.vue?vue&type=script&lang=js"
export * from "./ExtratoTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports